export const formatMoney = (number, $show_symbol = true) => {

    if(number === "") return number;

    if ($show_symbol) {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number)
    }
    return new Intl.NumberFormat('de-DE', {}).format(number)
}